/**
 * Sentry client init. Skipped when REACT_APP_SENTRY_DSN isn't set
 * (local dev). Imported once from index.tsx before <App/> renders.
 *
 * - send-default-pii is false: no IP / user-agent / cookies sent
 *   automatically.
 * - tracesSampleRate stays at 0 by default to keep our Sentry
 *   quota free; flip via env when we want APM data.
 * - browserTracingIntegration is opt-in (only when traces > 0).
 */
import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;
const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || 'production';
const release = process.env.REACT_APP_SENTRY_RELEASE;
const tracesSampleRate = parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0');

if (dsn) {
  Sentry.init({
    dsn,
    environment,
    release,
    tracesSampleRate,
    integrations: tracesSampleRate > 0 ? [Sentry.browserTracingIntegration()] : [],
    sendDefaultPii: false,
    // Don't ship local-only React strict-mode noise to Sentry.
    ignoreErrors: [
      // axios cancellation
      'AbortError',
      'Request aborted',
      // browser quirks
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      // user network drops
      'Network Error',
      'Failed to fetch',
    ],
    // Drop a few high-noise / 4xx-ish events that bloat Sentry without
    // being actionable.
    beforeSend(event, hint) {
      const status = (hint?.originalException as any)?.response?.status;
      if (status && status >= 400 && status < 500 && status !== 401 && status !== 403) {
        return null;
      }
      return event;
    },
  });
}

export { Sentry };
